import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { getDebugOffset, resetSessionRotation } from './lib/boostRotation';
import { AuthProvider } from './context/AuthContext';
import { LanguageProvider } from './context/LanguageContext';
import EditListingPage from './pages/EditListingPage';
import Navbar from './components/Navbar';
import PartnerPage from './pages/PartnerPage';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import ListingsPage from './pages/ListingsPage';
import PropertyDetailPage from './pages/PropertyDetailPage';
import LoginPage from './pages/LoginPage.js';
import RegisterPage from './pages/RegisterPage.js';
import ListPropertyPage from './pages/ListPropertyPage';
import ValuationPage from './pages/ValuationPage';
import ProfilePage from './pages/ProfilePage';
import MyListingsPage from './pages/MyListingsPage';
import InboxPage from './pages/InboxPage';
import SettingsPage from './pages/SettingsPage';
import NeighbourhoodPage from './pages/NeighbourhoodPage';
import NeighbourhoodDetailPage from './pages/NeighbourhoodDetailPage';
import RenovationPage from './pages/RenovationPage';
import CheckoutPage from './pages/CheckoutPage';
import SavedPage from './pages/SavedPage';
import MortgageCalculatorPage from './pages/MortgageCalculatorPage';
import NotificationsPage from './pages/NotificationsPage';
import AboutPage from './pages/AboutPage';
import LegalIndexPage from './pages/legal/LegalIndexPage';
import TermsPage from './pages/legal/TermsPage';
import PrivacyPage from './pages/legal/PrivacyPage';
import CookiesPage from './pages/legal/CookiesPage';
import DisclaimerPage from './pages/legal/DisclaimerPage';
import AcceptableUsePage from './pages/legal/AcceptableUsePage';
import BillingPage from './pages/legal/BillingPage';
import BoostPage from './pages/BoostPage';
import BoostCheckoutPage from './pages/BoostCheckoutPage';
import BoostSelectPage from './pages/BoostSelectPage';
import BoostSuccessPage from './pages/BoostSuccessPage';
import ContactPage from './pages/ContactPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import BrokerProfilePage from './pages/BrokerProfilePage';
import AllPartnersPage from './pages/AllPartnersPage';
import FAQPage from './pages/FAQPage';
import AuthCallback from './pages/AuthCallback';
import VerifyEmailPage from './pages/VerifyEmailPage';
import ProPage from './pages/ProPage';
import AgentDashboard from './pages/AgentDashboard';
import FindAgentPage from './pages/FindAgentPage';
import FindAgentSuccessPage from './pages/FindAgentSuccessPage';
import NotFoundPage from './pages/NotFoundPage';
import PageTracker from './components/PageTracker';
import SupportChat from './components/SupportChat';
import ScrollToTop from './components/ScrollToTop';
import CookieConsent from './components/CookieConsent';
import { releaseAllBodyScrollLocks } from './lib/bodyScrollLock';

// Safety net: clear every body-scroll lock holder on route change so a stuck
// overflow:hidden from a previous screen can never bleed into the next one.
// Modals/sheets that span route changes would have to be re-acquired in the
// new screen's effect, which is the correct behaviour anyway.
function BodyScrollLockSafety() {
  const { pathname } = useLocation();
  useEffect(() => { releaseAllBodyScrollLocks(); }, [pathname]);
  return null;
}


function AppRoutes() {
  const location = useLocation();
  const { pathname } = useLocation();
useEffect(() => {
  const titles = {
    '/':                'CosmoEstates — Cyprus Property Portal',
    '/listings':        'Property Listings in Cyprus | CosmoEstates',
    '/valuation':       'Free Property Price Estimate Cyprus | CosmoEstates',
    '/mortgage':        'Mortgage Calculator Cyprus | CosmoEstates',
    '/renovation':      'Renovation Planner Cyprus | CosmoEstates',
    '/neighbourhood':   'Neighbourhood Intelligence Cyprus | CosmoEstates',
    '/login':           'Sign In | CosmoEstates',
    '/register':        'Create Account | CosmoEstates',
    '/checkout':        'Go Pro | CosmoEstates',
    '/settings':        'Account Settings | CosmoEstates',
    '/my-listings':     'My Listings | CosmoEstates',
    '/boost-select':    'Boost Listings | CosmoEstates',
    '/list-property':   'List a Property | CosmoEstates',
    '/notifications':   'Notifications | CosmoEstates',
    '/watchlist':       'My Watchlist | CosmoEstates',
    '/find-agent':      'Find an Agent in Cyprus | CosmoEstates',
  };
  document.title = titles[pathname] || 'CosmoEstates — Cyprus Property Portal';

  // Per-route meta description. Keep each unique — search engines penalise
  // dupes and it looks unprofessional to anyone inspecting the source. Falls
  // back to the homepage description for any route not listed. Pages that own
  // their own <meta> (e.g. LegalPage) will overwrite this on mount and
  // restore the previous value on unmount — order-safe.
  const descriptions = {
    '/':                "CosmoEstates — Cyprus property marketplace with sourced data, transparent pricing, and honest neighbourhood intelligence. Find your home in Cyprus.",
    '/listings':        "Browse property listings across Cyprus — Limassol, Larnaca, Paphos, Nicosia, Famagusta. Filter by price, type, and district.",
    '/neighbourhood':   "Explore Cyprus neighbourhoods with data-backed transport, schools, and amenities scores. Sourced from real public data, not opinion.",
    '/methodology':     "How CosmoEstates sources every data point — from Central Bank of Cyprus property indices to GTFS transport data.",
    '/valuation':       "Get a data-informed price estimate for property in Cyprus. Powered by real market data — not guesswork.",
    '/faq':             "Frequently asked questions about CosmoEstates — listing, pricing, boosting, buying, and how the platform works.",
    '/about':           "About CosmoEstates — a Cyprus property marketplace built on honest, sourced data.",
    '/contact':         "Contact CosmoEstates — get in touch with our team about listings, partnerships, or platform questions.",
  };
  const desc = descriptions[pathname] || descriptions['/'];
  let descTag = document.querySelector('meta[name="description"]');
  if (!descTag) {
    descTag = document.createElement('meta');
    descTag.setAttribute('name', 'description');
    document.head.appendChild(descTag);
  }
  descTag.setAttribute('content', desc);
  const ogDesc = document.querySelector('meta[property="og:description"]');
  if (ogDesc) ogDesc.setAttribute('content', desc);
  const twDesc = document.querySelector('meta[name="twitter:description"]');
  if (twDesc) twDesc.setAttribute('content', desc);
}, [pathname]);
  return (
    <Routes>
      <Route path="/edit-listing/:id" element={<EditListingPage />} />
      <Route path="/login"             element={<LoginPage />} />
      <Route path="/register"          element={<RegisterPage />} />
      <Route path="/list-property"     element={<><Navbar /><ListPropertyPage /></>} />
      <Route path="/find-agent"         element={<><Navbar /><FindAgentPage /><Footer /></>} />
      <Route path="/find-agent/success" element={<><Navbar /><FindAgentSuccessPage /><Footer /></>} />
      <Route path="/find-broker/:id"   element={<BrokerProfilePage />} />
      <Route path="/broker/:brokerId/listings" element={<><Navbar /><ListingsPage /><Footer /></>} />
      <Route path="/valuation"         element={<><Navbar /><ValuationPage /><Footer /></>} />
      <Route path="/notifications"     element={<NotificationsPage />} />
      <Route path="/boost"             element={<><Navbar /><BoostPage /><Footer /></>} />
      <Route path="/boost-select"      element={<><Navbar /><BoostSelectPage key={location.key} /></>} />
      <Route path="/boost-checkout"    element={<><Navbar /><BoostCheckoutPage key={location.key} /><Footer /></>} />
      <Route path="/boost-success"     element={<BoostSuccessPage />} />
      <Route path="/forgot-password"   element={<ForgotPasswordPage />} />
      <Route path="/reset-password"    element={<ResetPasswordPage />} />
      <Route path="/auth/callback"     element={<AuthCallback />} />
      <Route path="/verify-email"      element={<VerifyEmailPage />} />
      <Route path="/"                  element={<><Navbar /><HomePage /><Footer /></>} />
      <Route path="/listings"          element={<><Navbar /><ListingsPage /><Footer /></>} />
      <Route path="/property/:id"      element={<><Navbar /><PropertyDetailPage /><Footer /></>} />
      <Route path="/profile"           element={<><Navbar /><ProfilePage /><Footer /></>} />
      <Route path="/my-listings"       element={<><Navbar /><MyListingsPage key={location.key} /><Footer /></>} />
      <Route path="/inbox"             element={<><Navbar /><InboxPage /><Footer /></>} />
      <Route path="/settings"          element={<><Navbar /><SettingsPage /><Footer /></>} />
      <Route path="/neighbourhood"     element={<><Navbar /><NeighbourhoodPage /><Footer /></>} />
      <Route path="/neighbourhood/:id" element={<><Navbar /><NeighbourhoodDetailPage /><Footer /></>} />
      <Route path="/renovation"        element={<><Navbar /><RenovationPage /><Footer /></>} />
      <Route path="/mortgage"          element={<><Navbar /><MortgageCalculatorPage /><Footer /></>} />
      <Route path="/partners"     element={<><Navbar /><AllPartnersPage /><Footer /></>} />
      <Route path="/partner/:slugOrId" element={<><Navbar /><PartnerPage /><Footer /></>} />
      <Route path="/pro"               element={<><Navbar /><ProPage /><Footer /></>} />
      <Route path="/checkout"          element={<><Navbar /><CheckoutPage /><Footer /></>} />
      <Route path="/saved"             element={<><Navbar /><SavedPage /><Footer /></>} />
      <Route path="/about"             element={<><Navbar /><AboutPage /><Footer /></>} />

      {/* Legal pages — single source rendered from /docs/legal/*.md.
          Old paths redirect to the new short paths so any existing inbound
          links (search engines, emails, third-party pages) keep working. */}
      <Route path="/legal"             element={<><Navbar /><LegalIndexPage /><Footer /></>} />
      <Route path="/terms"             element={<><Navbar /><TermsPage /><Footer /></>} />
      <Route path="/privacy"           element={<><Navbar /><PrivacyPage /><Footer /></>} />
      <Route path="/cookies"           element={<><Navbar /><CookiesPage /><Footer /></>} />
      <Route path="/disclaimer"        element={<><Navbar /><DisclaimerPage /><Footer /></>} />
      <Route path="/acceptable-use"    element={<><Navbar /><AcceptableUsePage /><Footer /></>} />
      <Route path="/billing"           element={<><Navbar /><BillingPage /><Footer /></>} />

      <Route path="/privacy-policy"    element={<Navigate to="/privacy" replace />} />
      <Route path="/terms-of-service"  element={<Navigate to="/terms" replace />} />
      <Route path="/terms-of-use"      element={<Navigate to="/terms" replace />} />
      <Route path="/cookies-policy"    element={<Navigate to="/cookies" replace />} />
      <Route path="/contact"            element={<><Navbar /><ContactPage /><Footer /></>} />
      <Route path="/faq"               element={<><Navbar /><FAQPage /><Footer /></>} />
      <Route path="/dashboard"         element={<AgentDashboard />} />

      <Route path="*"                  element={<><Navbar /><NotFoundPage /><Footer /></>} />
    </Routes>
  );
}

// Floating debug panel — only visible when URL contains ?dev=true
function BoostDevPanel() {
  const [visible, setVisible] = useState(false);
  const [offset, setOffset]   = useState(null);

  useEffect(() => {
    setVisible(new URLSearchParams(window.location.search).get('dev') === 'true');
    setOffset(getDebugOffset());
  }, []);

  if (!visible) return null;

  const panelStyle = {
    position: 'fixed', bottom: 16, right: 16, zIndex: 9999,
    background: '#1A0A2E', color: 'white', borderRadius: 10,
    padding: '12px 16px', fontSize: 12, fontFamily: 'monospace',
    boxShadow: '0 4px 24px rgba(0,0,0,0.4)', minWidth: 220,
  };

  return (
    <div style={panelStyle}>
      <div style={{ fontWeight: 700, marginBottom: 8, color: '#D4ADFF' }}>
        Boost Rotation (dev)
      </div>
      <div style={{ marginBottom: 6 }}>
        Session offset: <strong style={{ color: '#FBB033' }}>{offset ?? '—'}</strong>
      </div>
      <div style={{ marginBottom: 10, color: '#9D6FD4', fontSize: 11 }}>
        {sessionStorage.getItem('boost_session_id')?.slice(0, 18)}…
      </div>
      <button
        onClick={resetSessionRotation}
        style={{
          background: '#5B2D8E', color: 'white', border: 'none',
          borderRadius: 6, padding: '6px 12px', fontSize: 12,
          cursor: 'pointer', fontFamily: 'monospace', width: '100%',
        }}
      >
        Reset rotation &amp; reload
      </button>
    </div>
  );
}

function App() {
  return (
    <LanguageProvider>
    <AuthProvider>
      <Router>
        <ScrollToTop />
        <BodyScrollLockSafety />
        <PageTracker />
        <AppRoutes />
        <BoostDevPanel />
        <SupportChat />
        <CookieConsent />
      </Router>
    </AuthProvider>
    </LanguageProvider>
  );
}

export default App;